export default {
  // Endpoints
  loginEndpoint: '/jwt/login',
  registerEndpoint: '/jwt/register',
  refreshEndpoint: '/jwt/refresh-token',
  logoutEndpoint: '/jwt/logout',
  
  // Magic Link Endpoints
  magicLinkEndpoint: '/auth/magic-link',
  verifyMagicLinkEndpoint: '/auth/verify-magic-link',
  confirmMagicLinkEndpoint: '/auth/confirm-magic-link',

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken',
}
